module.exports = __webpack_public_path__ + "media/theme/steps--1--open-82bea5b0.png";